import React, { useState } from 'react'
import "./aicore.css"
import { NavLink } from 'react-router-dom'
import { Container } from 'react-bootstrap'


const pieData = {
  "core": {
    "title": "AI CORE",
    "description": "GenAI · Agentic workflows · ML models · Automation",
    "ringText": "HUMAN GOVERNANCE",
    "bottomText": "Review · Validate · Contextualise · Own"
  },
  "nodes": [
    {
      "id": "investment-analysis",
      "title": "INVESTMENT ANALYSIS",
      "subtitle": "Screening · Diligence · Valuation",
      "icon": "investment",
      "svg": '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.0199 8.05964C13.8628 7.61336 13.5711 7.22682 13.1851 6.95334C12.799 6.67986 12.3376 6.53292 11.8645 6.53278H10.093C9.59051 6.5342 9.10616 6.72094 8.73275 7.05725C8.35935 7.39357 8.12313 7.85581 8.06935 8.35545C8.01556 8.8551 8.14798 9.35703 8.44126 9.76511C8.73453 10.1732 9.16803 10.4587 9.65875 10.5671L12.3513 11.1568C12.9023 11.277 13.3893 11.5967 13.7188 12.0543C14.0483 12.512 14.197 13.0753 14.1364 13.6359C14.0757 14.1966 13.8099 14.715 13.3901 15.0915C12.9703 15.468 12.4261 15.6761 11.8622 15.6756H10.3376C9.86504 15.6758 9.40403 15.5296 9.01803 15.257C8.63203 14.9843 8.34001 14.5988 8.18218 14.1534M11.1033 6.53278V4.24707M11.1033 17.9614V15.6756M15.4622 30.4574V18.4574C15.4622 17.6996 15.7632 16.9729 16.299 16.4371C16.8348 15.9012 17.5616 15.6002 18.3193 15.6002C19.0771 15.6002 19.8038 15.9012 20.3396 16.4371C20.8754 16.9729 21.1765 17.6996 21.1765 18.4574V24.7431H25.7479C26.9603 24.7431 28.1231 25.2247 28.9804 26.082C29.8377 26.9393 30.3193 28.1021 30.3193 29.3145V30.4574" stroke="#11E9C7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.1052 21.4632C8.99631 21.4629 6.9378 20.8188 5.20485 19.6171C3.47191 18.4153 2.14713 16.7132 1.4763 14.7383C0.668132 12.7633 0.549163 10.6097 1.06663 8.5653C1.58409 6.52093 2.71333 4.68324 4.30336 3.29794C5.89339 1.91264 7.86844 1.04575 9.96442 0.813181C12.0604 0.580612 14.1775 0.993444 16.0325 1.99648C17.8875 2.99952 19.3922 4.54496 20.3452 6.42617C21.2982 8.30738 21.6543 10.4347 21.3657 12.5237" stroke="#11E9C7" stroke-width="1.5" stroke-linecap="round"/></svg>',
      "position": "top",
      "active": true
    },
    {
      "id": "strategy-planning",
      "title": "STRATEGY & PLANNING",
      "subtitle": "Research · Planning · GTM",
      "icon": "strategy",
      "svg":'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 27.3333C9.33333 14.6667 15.3333 10.6667 26.6667 8" stroke="#01C6B2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.212 5.08L27.1933 7.86667L24.404 13.848M21.3333 26.9907L24.1613 24.1613M24.1613 24.1613L26.9907 21.3333M24.1613 24.1613L21.3333 21.3333M24.1613 24.1613L26.9907 26.9907M6.66667 9.33333C7.37391 9.33333 8.05219 9.05238 8.55228 8.55229C9.05238 8.05219 9.33333 7.37391 9.33333 6.66667C9.33333 5.95942 9.05238 5.28115 8.55228 4.78105C8.05219 4.28095 7.37391 4 6.66667 4C5.95942 4 5.28115 4.28095 4.78105 4.78105C4.28095 5.28115 4 5.95942 4 6.66667C4 7.37391 4.28095 8.05219 4.78105 8.55229C5.28115 9.05238 5.95942 9.33333 6.66667 9.33333Z" stroke="#01C6B2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      "position": "top-right"
    },
    {
      "id": "portfolio-management",
      "title": "PORTFOLIO MANAGEMENT",
      "subtitle": "Monitoring · Risk · Reporting",
      "icon": "portfolio",
      "svg":'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.00156 7.63785L4.00499 7.71443V10.2859H10.7684C11.1467 10.2859 11.5101 10.135 11.7776 9.86757L13.9318 7.71443L11.7798 5.56128C11.6472 5.42864 11.4897 5.32342 11.3163 5.25165C11.143 5.17988 10.9572 5.14296 10.7696 5.143H6.57185C5.90312 5.143 5.2607 5.40351 4.78085 5.86928C4.301 6.33505 4.02147 6.96942 4.00156 7.63785ZM2.2907 11.2299L2.28613 11.143V7.71443C2.28613 6.57778 2.73766 5.48769 3.54139 4.68397C4.34512 3.88024 5.43521 3.42871 6.57185 3.42871H10.7684C11.6016 3.42871 12.4004 3.76014 12.9901 4.34871L15.4987 6.85728H25.4301C26.5666 6.85759 27.6564 7.30925 28.4599 8.11294C29.2633 8.91664 29.7147 10.0066 29.7147 11.143V23.143C29.7147 24.2796 29.2632 25.3697 28.4594 26.1735C27.6557 26.9772 26.5656 27.4287 25.429 27.4287H6.57528C5.43863 27.4287 4.34855 26.9772 3.54482 26.1735C2.74109 25.3697 2.28956 24.2796 2.28956 23.143L2.2907 11.2299ZM4.00499 12.0001V23.143C4.00499 23.825 4.27591 24.479 4.75814 24.9613C5.24038 25.4435 5.89443 25.7144 6.57642 25.7144H25.429C26.111 25.7144 26.765 25.4435 27.2473 24.9613C27.7295 24.479 28.0004 23.825 28.0004 23.143V11.143C28.0004 10.461 27.7295 9.80696 27.2473 9.32472C26.765 8.84249 26.111 8.57157 25.429 8.57157H15.4976L12.9901 11.0801C12.4008 11.6692 11.6017 12.0001 10.7684 12.0001H4.00499Z" fill="#01C6B2"/></svg>',
      "position": "right"
    },
    {
      "id": "finance",
      "title": "FINANCE",
      "subtitle": "FP&A · MIS · Cash Flow",
      "icon": "finance",
      "svg":'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.66699 21.9695C6.44033 24.9435 10.3063 24.5002 12.595 24.4302M3.66699 18.2495C6.19033 21.1295 9.53699 21.3575 12.7097 20.9962M12.385 11.6362C2.28366 9.51754 1.03699 18.6589 12.385 17.6055M14.263 24.2015C16.8983 26.9349 25.7943 27.5482 28.3337 23.9149M14.263 20.0235C16.237 23.6569 25.4077 23.6075 28.3337 20.3102M14.263 16.4469C18.383 20.7662 25.9297 19.2882 28.3337 16.4469" stroke="#01C6B2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.2627 12.8691C16.86 16.4465 25.4094 16.5505 28.3334 12.9265" stroke="#01C6B2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21.3098 12.1524C24.9446 12.1524 27.8912 10.6752 27.8912 8.85304C27.8912 7.03087 24.9446 5.55371 21.3098 5.55371C17.6751 5.55371 14.7285 7.03087 14.7285 8.85304C14.7285 10.6752 17.6751 12.1524 21.3098 12.1524Z" stroke="#01C6B2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.3848 11.6357V17.6051" stroke="#01C6B2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      "position": "bottom-right"
    },
    {
      "id": "operations",
      "title": "OPERATIONS",
      "subtitle": "Process · Workflow · Reporting",
      "icon": "operations",
      "svg":'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0002 21.7602C12.8002 21.7602 10.2402 19.2002 10.2402 16.0002C10.2402 12.8002 12.8002 10.2402 16.0002 10.2402C19.2002 10.2402 21.7602 12.8002 21.7602 16.0002C21.7602 19.2002 19.2002 21.7602 16.0002 21.7602ZM16.0002 11.5202C13.5042 11.5202 11.5202 13.5042 11.5202 16.0002C11.5202 18.4962 13.5042 20.4802 16.0002 20.4802C18.4962 20.4802 20.4802 18.4962 20.4802 16.0002C20.4802 13.5042 18.4962 11.5202 16.0002 11.5202Z" fill="#11E9C7"/><path d="M17.7278 28.1598H14.2718L13.3118 25.2158C12.6718 25.0238 12.0318 24.7678 11.4558 24.4478L8.63984 25.8558L6.20784 23.4238L7.61584 20.6078C7.29584 20.0318 7.03984 19.3918 6.84784 18.7518L3.83984 17.7278V14.2718L6.78384 13.3118C6.97584 12.6718 7.23184 12.0318 7.55184 11.4558L6.14384 8.63984L8.57584 6.20784L11.3918 7.61584C11.9678 7.29584 12.6078 7.03984 13.2478 6.84784L14.2718 3.83984H17.7278L18.6878 6.78384C19.3278 6.97584 19.9678 7.23184 20.5438 7.55184L23.3598 6.14384L25.7918 8.57584L24.3838 11.3918C24.7038 11.9678 24.9598 12.6078 25.1518 13.2478L28.0958 14.2078V17.6638L25.1518 18.6238C24.9598 19.2638 24.7038 19.9038 24.3838 20.4798L25.7918 23.2958L23.3598 25.7278L20.5438 24.3198C19.9678 24.6398 19.3278 24.8958 18.6878 25.0878L17.7278 28.1598ZM15.1678 26.8798H16.8318L17.7278 24.1278L18.0478 24.0638C18.8158 23.8718 19.5198 23.5518 20.2238 23.1678L20.5438 22.9758L23.1038 24.2558L24.2558 23.1038L22.9758 20.5438L23.1678 20.2238C23.5518 19.5838 23.8718 18.8158 24.0638 18.0478L24.1278 17.7278L26.8798 16.8318V15.1678L24.1278 14.2718L24.0638 13.9518C23.8718 13.1838 23.5518 12.4798 23.1678 11.7758L22.9758 11.4558L24.2558 8.89584L23.1038 7.74384L20.5438 9.02384L20.2238 8.83184C19.5198 8.44784 18.8158 8.12784 18.0478 7.93584L17.7278 7.87184L16.8318 5.11984H15.1678L14.2718 7.87184L13.9518 7.93584C13.1838 8.12784 12.4798 8.44784 11.7758 8.83184L11.4558 9.02384L8.89584 7.74384L7.74384 8.89584L9.02384 11.4558L8.83184 11.7758C8.44784 12.4158 8.12784 13.1838 7.93584 13.9518L7.87184 14.2718L5.11984 15.1678V16.8318L7.87184 17.7278L7.93584 18.0478C8.12784 18.8158 8.44784 19.5198 8.83184 20.2238L9.02384 20.5438L7.74384 23.1038L8.89584 24.2558L11.4558 22.9758L11.7758 23.1678C12.4798 23.5518 13.1838 23.8718 13.9518 24.0638L14.2718 24.1278L15.1678 26.8798Z" fill="#11E9C7"/></svg>',
      "position": "bottom"
    },
    {
      "id": "sales-growth",
      "title": "SALES & GROWTH",
      "subtitle": "Pipeline · Outreach · Proposals",
      "icon": "sales",
      "svg":'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 6V4H27V2H25V4H24C22.897 4 22 4.898 22 6V8C22 9.103 22.897 10 24 10H28V12H22V14H25V16H27V14H28C29.103 14 30 13.103 30 12V10C30 8.898 29.103 8 28 8H24V6H30ZM24 20V22H26.586L23 25.586L20.708 23.293C20.5208 23.1057 20.2668 23.0003 20.002 23H20C19.7352 23.0003 19.4812 23.1057 19.294 23.293L14 28.586L15.414 30L20.001 25.414L22.293 27.707C22.4805 27.8945 22.7348 27.9998 23 27.9998C23.2652 27.9998 23.5195 27.8945 23.707 27.707L28 23.414V26H30V20H24ZM4 30H2V25C2 21.14 5.14 18 9 18H15C16.989 18 18.89 18.85 20.217 20.333L18.727 21.667C18.258 21.1426 17.6836 20.723 17.0414 20.4358C16.3992 20.1485 15.7035 20 15 20H9C6.243 20 4 22.243 4 25V30ZM12 16C13.8565 16 15.637 15.2625 16.9497 13.9497C18.2625 12.637 19 10.8565 19 9C19 7.14348 18.2625 5.36301 16.9497 4.05025C15.637 2.7375 13.8565 2 12 2C10.1435 2 8.36301 2.7375 7.05025 4.05025C5.7375 5.36301 5 7.14348 5 9C5 10.8565 5.7375 12.637 7.05025 13.9497C8.36301 15.2625 10.1435 16 12 16ZM12 4C13.3261 4 14.5979 4.52678 15.5355 5.46447C16.4732 6.40215 17 7.67392 17 9C17 10.3261 16.4732 11.5979 15.5355 12.5355C14.5979 13.4732 13.3261 14 12 14C10.6739 14 9.40215 13.4732 8.46447 12.5355C7.52678 11.5979 7 10.3261 7 9C7 7.67392 7.52678 6.40215 8.46447 5.46447C9.40215 4.52678 10.6739 4 12 4Z" fill="#11E9C7"/></svg>',
      "position": "bottom-left"
    },
    {
      "id": "human-capital",
      "title": "HUMAN CAPITAL",
      "subtitle": "Org design · Workforce · Appraisals",
      "icon": "human",
      "svg":'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 20H30V30H20V20H24V16H6V20H10V30H0V20H4V14H14V10H10V0H20V10H16V14H26V20ZM12 2V8H18V2H12ZM8 28V22H2V28H8ZM28 28V22H22V28H28Z" fill="#11E9C7"/></svg>',
      "position": "left"
    },
    {
      "id": "data-technology",
      "title": "DATA & TECHNOLOGY",
      "subtitle": "BI · Pipelines · Dashboards",
      "icon": "technology",
      "svg":'<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3333 6.66667L16 4M10.6667 21.3333L21.3333 10.6667M16 28L18.6667 25.3333M22 25.3333C22.8841 25.3333 23.7319 24.9821 24.357 24.357C24.9821 23.7319 25.3333 22.8841 25.3333 22C25.3333 21.1159 24.9821 20.2681 24.357 19.643C23.7319 19.0179 22.8841 18.6667 22 18.6667C21.1159 18.6667 20.2681 19.0179 19.643 19.643C19.0179 20.2681 18.6667 21.1159 18.6667 22C18.6667 22.8841 19.0179 23.7319 19.643 24.357C20.2681 24.9821 21.1159 25.3333 22 25.3333ZM10 13.3333C10.8841 13.3333 11.7319 12.9821 12.357 12.357C12.9821 11.7319 13.3333 10.8841 13.3333 10C13.3333 9.11595 12.9821 8.2681 12.357 7.64298C11.7319 7.01786 10.8841 6.66667 10 6.66667C9.11595 6.66667 8.2681 7.01786 7.64298 7.64298C7.01786 8.2681 6.66667 9.11595 6.66667 10C6.66667 10.8841 7.01786 11.7319 7.64298 12.357C8.2681 12.9821 9.11595 13.3333 10 13.3333ZM7.33333 28C8.21739 28 9.06523 27.6488 9.69036 27.0237C10.3155 26.3986 10.6667 25.5507 10.6667 24.6667C10.6667 23.7826 10.3155 22.9348 9.69036 22.3096C9.06523 21.6845 8.21739 21.3333 7.33333 21.3333C6.44928 21.3333 5.60143 21.6845 4.97631 22.3096C4.35119 22.9348 4 23.7826 4 24.6667C4 25.5507 4.35119 26.3986 4.97631 27.0237C5.60143 27.6488 6.44928 28 7.33333 28ZM24.6667 10.6667C25.5507 10.6667 26.3986 10.3155 27.0237 9.69036C27.6488 9.06523 28 8.21739 28 7.33333C28 6.44928 27.6488 5.60143 27.0237 4.97631C26.3986 4.35119 25.5507 4 24.6667 4C23.7826 4 22.9348 4.35119 22.3096 4.97631C21.6845 5.60143 21.3333 6.44928 21.3333 7.33333C21.3333 8.21739 21.6845 9.06523 22.3096 9.69036C22.9348 10.3155 23.7826 10.6667 24.6667 10.6667Z" stroke="#01C6B2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      "position": "top-left"
    }
  ]
}

// const iconMap = {
//   investment: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.0199 8.05964C13.8628 7.61336 13.5711 7.22682 13.1851 6.95334C12.799 6.67986 12.3376 6.53292 11.8645 6.53278H10.093C9.59051 6.5342 9.10616 6.72094 8.73275 7.05725C8.35935 7.39357 8.12313 7.85581 8.06935 8.35545C8.01556 8.8551 8.14798 9.35703 8.44126 9.76511C8.73453 10.1732 9.16803 10.4587 9.65875 10.5671L12.3513 11.1568C12.9023 11.277 13.3893 11.5967 13.7188 12.0543C14.0483 12.512 14.197 13.0753 14.1364 13.6359C14.0757 14.1966 13.8099 14.715 13.3901 15.0915C12.9703 15.468 12.4261 15.6761 11.8622 15.6756H10.3376C9.86504 15.6758 9.40403 15.5296 9.01803 15.257C8.63203 14.9843 8.34001 14.5988 8.18218 14.1534M11.1033 6.53278V4.24707M11.1033 17.9614V15.6756M15.4622 30.4574V18.4574C15.4622 17.6996 15.7632 16.9729 16.299 16.4371C16.8348 15.9012 17.5616 15.6002 18.3193 15.6002C19.0771 15.6002 19.8038 15.9012 20.3396 16.4371C20.8754 16.9729 21.1765 17.6996 21.1765 18.4574V24.7431H25.7479C26.9603 24.7431 28.1231 25.2247 28.9804 26.082C29.8377 26.9393 30.3193 28.1021 30.3193 29.3145V30.4574" stroke="#11E9C7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.1052 21.4632C8.99631 21.4629 6.9378 20.8188 5.20485 19.6171C3.47191 18.4153 2.14713 16.7132 1.4763 14.7383C0.668132 12.7633 0.549163 10.6097 1.06663 8.5653C1.58409 6.52093 2.71333 4.68324 4.30336 3.29794C5.89339 1.91264 7.86844 1.04575 9.96442 0.813181C12.0604 0.580612 14.1775 0.993444 16.0325 1.99648C17.8875 2.99952 19.3922 4.54496 20.3452 6.42617C21.2982 8.30738 21.6543 10.4347 21.3657 12.5237" stroke="#11E9C7" stroke-width="1.5" stroke-linecap="round"/></svg>',
//   strategy: GitBranch,
//   portfolio: BriefcaseBusiness,
//   finance: Coins,
//   operations: Settings,
//   sales: DollarSign,
//   human: Network,
//   technology: Database
// };

const sectionData = {
  "investment-analysis": {
    "function": "FUNCTION 01",
    "title": "Investment Analysis",
    "goal": "Widen the funnel and reach conviction faster screening more opportunities without trading away analytical rigor.",
    "challenge": "Manual diligence and data-room grind keep lean deal teams reactive; by the time the analysis lands, the opportunity has repriced.",
    "coreInAction": "AI runs screening, sizing, and first-draft diligence at machine speed our investment professionals validate every assumption, so what reaches your IC is decision-grade.",
    "linkText": "Explore Investment Analysis Case Studies →"
  },

  "strategy-planning": {
    "function": "FUNCTION 02",
    "title": "Strategy & Planning",
    "goal": "Move into new markets, products, and partnerships with conviction every bet underwritten by evidence, not instinct.",
    "challenge": "Market intelligence is fragmented and perishable, so strategic calls get made on signal that's already gone stale.",
    "coreInAction": "AI scans markets and competitors continuously to surface live signal our consultants pressure-test it and translate it into a defensible, board-ready plan.",
    "linkText": "Explore Strategy & Planning Case Studies →"
  },

  "portfolio-management": {
    "function": "FUNCTION 03",
    "title": "Portfolio Management",
    "goal": "A single pane of glass on performance and risk across every holding always-on, forward-looking oversight.",
    "challenge": "Value and risk data sit siloed across companies and spreadsheets, leaving oversight quarterly, backward-looking, and reactive.",
    "coreInAction": "AI consolidates portfolio data and flags anomalies around the clock our analysts interpret the value implications and act as your early-warning system.",
    "linkText": "Explore Portfolio Management Case Studies →"
  },

  "finance": {
    "function": "FUNCTION 04",
    "title": "Finance",
    "goal": "A faster close, sharper forecasts, and reporting that steers the business rather than just recording it.",
    "challenge": "Finance teams burn capacity assembling numbers instead of advising leadership turning every board pack into a fire drill.",
    "coreInAction": "AI automates MIS, forecasting, and variance analysis end-to-end our finance experts own the accuracy and the narrative behind the numbers.",
    "linkText": "Explore Finance Case Studies →"
  },

  "operations": {
    "function": "FUNCTION 05",
    "title": "Operations",
    "goal": "Real operating leverage leaner, faster processes where reporting keeps pace with the business.",
    "challenge": "Manual workflows, disconnected systems, and one-off requests quietly erode capacity across the back office.",
    "coreInAction": "AI orchestrates repetitive workflows and reporting end-to-end our operations experts redesign the process and stay accountable for the outcome.",
    "linkText": "Explore Operations Case Studies →"
  },

  "sales-growth": {
    "function": "FUNCTION 06",
    "title": "Sales & Growth",
    "goal": "A fuller pipeline and higher win rates outreach that stays personal even at scale.",
    "challenge": "Prospect research, list-building, and proposal drafting consume the hours that should be spent in front of clients.",
    "coreInAction": "AI researches accounts and drafts tailored collateral in minutes our team sharpens the positioning so every pitch lands with credibility.",
    "linkText": "Explore Sales & Growth Case Studies →"
  },

  "human-capital": {
    "function": "FUNCTION 07",
    "title": "Human Capital",
    "goal": "An organisation engineered to deliver the strategy the right structure, capabilities, and incentives, designed on evidence.",
    "challenge": "Staffing, org design, and performance systems get set on gut feel and scattered spreadsheets, so the structure lags the strategy.",
    "coreInAction": "AI models staffing scenarios, benchmarks capabilities, and powers live people dashboards our HR consultants turn that into org designs, appraisal frameworks, and hiring plans leadership can act on.",
    "linkText": "Explore Human Capital Case Studies →"
  },

  "data-technology": {
    "function": "FUNCTION 08",
    "title": "Data & Technology",
    "goal": "One source of truth clean, connected, AI-ready data powering decisions across the enterprise.",
    "challenge": "Fragmented systems, messy data, and dashboards nobody trusts keep analytics stuck in reporting mode.",
    "coreInAction": "AI accelerates pipelines, data cleaning, and model-building our data professionals architect for reliability, security, and adoption.",
    "linkText": "Explore Data & Technology Case Studies →"
  }
}

// const Sparkles = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.9997 25.333C21.5997 20.429 23.3677 18.6597 27.9997 17.333C23.3677 16.0063 21.5997 14.237 19.9997 9.33301C18.3997 14.237 16.6317 16.0063 11.9997 17.333C16.6317 18.6597 18.3997 20.429 19.9997 25.333ZM9.33301 13.333C10.133 10.8797 11.017 9.99567 13.333 9.33301C11.017 8.67034 10.133 7.78634 9.33301 5.33301C8.53301 7.78634 7.64901 8.67034 5.33301 9.33301C7.64901 9.99567 8.53301 10.8797 9.33301 13.333ZM11.333 26.6663C11.733 25.4397 12.1743 24.9983 13.333 24.6663C12.1743 24.3343 11.733 23.893 11.333 22.6663C10.933 23.893 10.4917 24.3343 9.33301 24.6663C10.4917 24.9983 10.933 25.4397 11.333 26.6663Z" stroke="#01C6B2" stroke-width="2" stroke-linejoin="round"/></svg>';




const AiCore = ({setBlank}) => {

    const defaultNode =   pieData.nodes.find((item) => item.active) || pieData.nodes[0];
    const [activeId, setActiveId] = useState(defaultNode.id);
    const activeSection = sectionData[activeId];

   const gotobyid = (id) => {
        setBlank(true);
        setTimeout(() => {            
            const element = document.getElementById('casestudies');
            window.scrollTo(0, element.offsetTop );
            setBlank(false);
        }, 100);
    }

  return (

    <>

    <section className="ai-core-section">
        <Container>
        
        <div className="ai-sercorevice-header">
          <div className="ai-core-eyebrow">
            <p>THE PS INTELLIGENCE CORE</p>
            <h2>Every function. AI-powered. Expert-governed.</h2>
         </div>
          <p>Faster answers, without the trade-off in rigor. AI engines at the core do the heavy lifting; a layer of experts governs every output; and the resulting intelligence flows to whichever function needs it, whenever it's needed.</p>
        </div>

        <div className="ai-sec-wrapper">

            {/* =========================
                LEFT - AI CORE DIAGRAM
            ========================== */}
            <div className="ai-core-diagram">

                <div className="ai-core-wrapper">

                {/* Connecting lines */}
                <div className="ai-core-lines">
                    {pieData.nodes.map((node) => (
                    <div
                        key={`line-${node.id}`}
                        className={`ai-core-line line-${node.position} ${
                        activeId === node.id ? "active" : ""
                        }`}
                    />
                    ))}
                </div>

                {/* AI CORE */}
                <div className="ai-core-circle">
                    {/* <div className='ai-core-bg'> */}

                    {/* <div className="ai-core-ring-text">
                    {pieData.core.ringText}
                    </div> */}

                    <div className="ai-core-inner">
                    <h3>{pieData.core.title}</h3>

                    <p>
                        {pieData.core.description}
                    </p>
                    </div>

                    {/* <div className="ai-core-bottom-text">
                    {pieData.core.bottomText}
                    </div> */}
                    {/* </div> */}
                </div>

                {/* Function nodes */}
                {pieData.nodes.map((node) => {
                    const Icon = node.svg;

                    const isActive = activeId === node.id;

                    return (
                    <button
                        key={node.id}
                        type="button"
                        className={`
                        ai-core-node
                        node-${node.position}
                        ${isActive ? "active" : ""}
                        `}
                        onMouseEnter={() => setActiveId(node.id)}
                        onFocus={() => setActiveId(node.id)}
                        onClick={() => setActiveId(node.id)}
                    >

                        <div className="ai-core-node-icon" dangerouslySetInnerHTML={{__html:Icon}}>
                        {/* <Icon size={30} strokeWidth={1.7} /> */}
                        </div>

                        <div className="ai-core-node-content">

                        <h4>{node.title}</h4>

                        <span>
                            {node.subtitle}
                        </span>

                        </div>

                    </button>
                    );
                })}

                </div>
            </div>


            {/* =========================
                RIGHT CONTENT
            ========================== */}
            <div className="ai-core-info">

                <div className="ai-core-info-header">

                <span className="ai-core-function">
                    {activeSection.function}
                </span>

                <h2>
                    {activeSection.title}
                </h2>

                </div>


                <div className="ai-core-copy">

                <div className="ai-core-copy-item">

                    <h3>THE GOAL</h3>

                    <p>
                    {activeSection.goal}
                    </p>

                </div>


                <div className="ai-core-copy-item">

                    <h3>THE CHALLENGE</h3>

                    <p>
                    {activeSection.challenge}
                    </p>

                </div>


                <div className="ai-core-action">

                    {/* <Sparkles
                    size={28}
                    strokeWidth={1.5}
                    /> */}
                    {/* <span dangerouslySetInnerHTML={{__html:Sparkles}}></span> */}
                    <h3>
                    AI IN ACTION
                    </h3>

                    <p>
                    {activeSection.coreInAction}
                    </p>

                </div>

                </div>


                <NavLink
                to="/knowledge"
                onClick={gotobyid}
                className="ai-core-link"
                >
                {activeSection.linkText}
                </NavLink>

            </div>
        </div>
        </Container>
    </section>

    </>
  )
}

export default AiCore